import { gsap, ScrollTrigger } from "@/composeables/gsap";

// section-locations: Ist ein Hintergrund-Medium gepflegt, dunkelt es beim Reveal
// per brightness auf 0.2 ab. Währenddessen fadet der Header-Text ein und die
// Standort-Buttons staffeln nacheinander rein. Ohne Hintergrund-Medium bleibt es
// bei der reinen Stagger-Einblendung (kein Abdunkeln).
export const init = () => {

    gsap.utils.toArray(".section-locations").forEach(function (section) {

        // Das eigentliche Bild ist das <img> (die <picture> ist ein Box-loser
        // Wrapper — ein filter auf ihr hätte keinen sichtbaren Effekt).
        const bgMedia = section.querySelector(".section__bg img");
        const header = section.querySelector(".section-locations__header");
        const items = gsap.utils.toArray(section.querySelectorAll(".section-locations__nav li"));

        const revealTargets = [header, ...items].filter(Boolean);
        if (!revealTargets.length && !bgMedia) return;

        // Startzustand: Text/Buttons transparent + leicht nach unten versetzt.
        if (revealTargets.length) gsap.set(revealTargets, { autoAlpha: 0, y: 24 });
        // Hintergrund-Bild startet ungedimmt.
        if (bgMedia) gsap.set(bgMedia, { filter: "brightness(1)", willChange: "filter" });

        ScrollTrigger.create({
            trigger: section,
            start: "top 80%",
            once: true,
            invalidateOnRefresh: true,
            onEnter() {
                const tl = gsap.timeline();
                // Hintergrund abdunkeln …
                if (bgMedia) {
                    tl.to(bgMedia, {
                        filter: "brightness(0.2)",
                        duration: 1.1,
                        ease: "power2.out",
                        onComplete() { gsap.set(bgMedia, { willChange: "auto" }); },
                    }, 0);
                }
                // … während Text + Standort-Buttons gestaffelt reinfaden.
                if (revealTargets.length) {
                    tl.to(revealTargets, {
                        autoAlpha: 1,
                        y: 0,
                        duration: 0.9,
                        ease: "expo",
                        stagger: 0.12,
                        overwrite: true,
                    }, 0.1);
                }
            },
        });

    });
}

export default init;
